<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in adList" :key="index">
        <a @click="jump(item.jumpType, item.bizId, item.url)">
          <img :imgpath="getImgUrlPlaceholder(item.imgPath)" v-lazy="require('../../assets/img/loading_ho.jpg')" />
        </a>
      </div>
    </div>
    <!-- <div class="swiper-wrapper">
      <div class="swiper-slide">
        <a href="#">
          <img src="../../assets/img/book-banner.png" />
        </a>
      </div>
      <div class="swiper-slide">
        <a href="#">
          <img src="../../assets/img/book-banner.png" />
        </a>
      </div>
      <div class="swiper-slide">
        <a href="#">
          <img src="../../assets/img/book-banner.png" />
        </a>
      </div>
    </div> -->
    <!-- Add Pagination -->
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from '../../assets/js/swiper'
import { getImg } from '../../services/urlService'

export default {
  name: 'swiper',
  props: ['adList'],
  data () {
    return {
      list: []
    }
  },
  methods: {
    jump(jumpType, id, openUrl) {
      this.$router.isBack = false;
      if (jumpType === -1){
        window.location.href=openUrl;
      }else if (jumpType === -2){
        window.open(openUrl,"_blank")
      } else if (jumpType === 2){
        this.$router.push(`/book/${id}`)
      } else if (jumpType === 3) {
        this.$router.push(`/purchase`)
      }
    },
    // toBook (id) {
    //   this.$router.isBack = false
    //   this.$router.push(`/book/${id}`)
    // },
    getImgUrl (path) {
      return getImg(path)
    },
    getImgUrlPlaceholder(path) {
      return `${path}_500_0.img`;
    },
    swiperInit () {
      // eslint-disable-next-line no-new
      new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 2500,
        autoplayDisableOnInteraction: false
      })
    }
  },
  mounted () {
    if (this.adList && this.adList.length > 0) {
      this.swiperInit()
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/swiper.css";
</style>
